export function Testim(){
  return <section className="testim">
    <div className="container">
        <img src="images/bg-quotes.png" alt="quote"/>
        <div className="testimonial">
            <div className="feed">
                <p>    Fylo has improved our team productivity by an order of magnitude. Since making the switch our team has 
                become a well-oiled collaboration machine.</p>
                <div className="people">
                    <img src="images/profile-1.jpg" alt="profile1" />
                     <div className="desc">
                        <h2>Satish Patel</h2>
                        <p>Founder & CEO, Huddle</p>
                     </div>
                </div>
            </div>
            <div className="feed">
                <p>    Fylo has improved our team productivity by an order of magnitude. Since making the switch our team has 
    become a well-oiled collaboration machine.</p>
                <div className="people">
                    <img src="images/profile-2.jpg" alt="profile1" />
                     <div className="desc">
                        <h2>Bruce McKenzie</h2>
                        <p>Founder & CEO, Huddle</p>
                     </div>
                </div>
            </div>
            <div className="feed">
                <p>   Fylo has improved our team productivity by an order of magnitude. Since making the switch our team has 
    become a well-oiled collaboration machine.</p>
                <div className="people">
                    <img src="images/profile-3.jpg" alt="profile1" />
                     <div className="desc">
                        <h2>Iva Boyd</h2>
                        <p>Founder & CEO, Huddle</p>
                     </div>
                </div>
            </div>
        </div>

    </div>
  </section>
}

export default Testim;